export const ex90ModelData = {
  model: "EX90",
  points: [
    {
      categoryNodeId: "cb4f686cfc38bf4fc0a801887d77be49",
      title: "Vehicle propulsion",
      x: 250,
      y: 150,
      hoverImg: "EX90_Vehicle_propulsion.webm",
      type: "video",
    },
      {
        categoryNodeId: "0ba2100fdcc93a85c0a801880b5b635a",
        title: "Thermal management",
        x: 340,
        y: 280,
        hoverImg: "EX90_Thermal_management.png",
        type: "image",
      },
    {
      categoryNodeId: "b4ca516625cc332fc0a80188702c16a6",
      title: "Electrical systems",
      x: 520,
      y: 150,
      hoverImg: "EX90_Electrical_system.webm",
      type: "video",
    },
    {
      categoryNodeId: "8fcfb157f349b675c0a801880b419a2a",
      title: "Infotainment, connectivity and multimedia",
      x: 420,
      y: 120,
      hoverImg: "EX90_Infotainment.png",
      type: "image",
    },
    {
      categoryNodeId: "03b1e2b3d5441cf5c0a801884aaed5f9",
      title: "Brake system",
      x: 470,
      y: 300,
      hoverImg: "EX90_Brake_system.png",
      type: "image",
    },
    {
      categoryNodeId: "f0e56be8f070f76cc0a80188561d763d",
      title: "Safety systems",
      x: 680,
      y: 30,
      hoverImg: "EX90_Safety_system.png",
      type: "image",
    },
    {
      categoryNodeId: "7b0c6d922b7d3cd2c0a8018850c5912d",
      title: "Wheel suspension",
      x: 480,
      y: 200,
      hoverImg: "EX90_Wheel_suspension.png",
      type: "image",
    },
    {
      categoryNodeId: "f33765e4998ab3eac0a801884176dbbd",
      title: "Wheels and rims",
      x: 740,
      y: 200,
      hoverImg: "EX90_Wheel_and_rims.png",
      type: "image",
    },
    {
      categoryNodeId: "e96d56c76a8606cfc0a801886ef035ae",
      title: "Body",
      x: 650,
      y: 240,
      hoverImg: "EX90_Body.png",
      type: "image",
    },
    {
      categoryNodeId: "6831b7432b7ea96fc0a801884f6e45d9",
      title: "Exterior",
      x: 680,
      y: 120,
      hoverImg: "EX90_Exterior.png",
      type: "image",
    },
    {
      categoryNodeId: "8fcf4db72b805150c0a8018871de0c88",
      title: "Interior",
      x: 620,
      y: 70,
      hoverImg: "EX90_Interior.png",
      type: "image",
    },
  ],
};